export type PlanId = 'free' | 'pay_once' | 'starter' | 'growth'

export interface Plan {
  id: PlanId
  name: string
  priceMonthly: number | null
  priceAnnualMonthly: number | null
  priceDisplay: string
  annualPriceDisplay?: string
  annualTotalDisplay?: string
  description: string
  audits: string
  features: string[]
  disabledFeatures?: string[]
  badge?: string
  highlighted?: boolean
  cta: string
  tagline?: string
  periodLabel?: string
}

export const PLANS: Plan[] = [
  {
    id: 'free',
    name: 'Free',
    priceMonthly: 0,
    priceAnnualMonthly: 0,
    priceDisplay: 'Free',
    description: 'Try one limited compliance audit',
    audits: '1 limited audit',
    tagline: 'No credit card required',
    features: [
      '1 limited audit',
      'All 11 regulatory frameworks',
      'Risk score dashboard',
      'Cited compliance gaps',
    ],
    cta: 'Run Free Audit',
    highlighted: false,
  },
  {
    id: 'pay_once',
    name: 'Starter',
    priceMonthly: 39,
    priceAnnualMonthly: null,
    priceDisplay: '$39',
    description: 'For one agreement without a subscription',
    audits: '1 full audit',
    tagline: 'Purchased credit never expires',
    periodLabel: '/document',
    features: [
      '1 full document audit',
      'All 11 regulatory frameworks',
      'AI violation detection',
      'AI auto-remediation',
      'PDF export report',
      'Credit rolls over until used',
    ],
    cta: 'Choose Starter',
    highlighted: false,
  },
  {
    id: 'starter',
    name: 'Professional',
    priceMonthly: 79,
    priceAnnualMonthly: null,
    priceDisplay: '$79',
    description: 'For practitioners reviewing agreements regularly',
    audits: '10 audits / month',
    tagline: '7-day free trial · $7.90 per audit',
    features: [
      '10 audits per month',
      '7-day free trial',
      '2 namespaces',
      '25 stored documents',
      'All 11 regulatory frameworks',
      'AI violation detection',
      'AI auto-remediation',
      'PDF export reports',
      'Unused credits roll over',
      'Email support',
    ],
    cta: 'Choose Professional',
    highlighted: true,
  },
  {
    id: 'growth',
    name: 'Team',
    priceMonthly: 249,
    priceAnnualMonthly: null,
    priceDisplay: '$249',
    description: 'For compliance teams reviewing at volume',
    audits: '50 audits / month',
    tagline: '7-day free trial · $4.98 per audit',
    features: [
      '50 audits per month',
      '7-day free trial',
      '3 team seats',
      '10 namespaces',
      '200 documents',
      'All 11 regulatory frameworks',
      'Critic verification (false-positive reduction)',
      'AI auto-remediation',
      'PDF export reports',
      'Real-time webhook alerts',
      'Unused credits roll over',
      'Priority email support (24h)',
    ],
    cta: 'Choose Team',
    highlighted: false,
  },
]

export const ENTERPRISE = {
  name: 'Enterprise',
  priceDisplay: 'Custom',
  description: 'For organizations with 500+ employees or regulated industries',
  features: [
    'Custom framework support',
    'On-premise or private cloud deployment',
    'Dedicated customer success manager',
    'Custom SSO + SCIM',
    'Contractual SLAs',
    'Bespoke integrations',
    'Security questionnaire support',
  ],
  cta: 'Contact Sales',
}
